import { render, staticRenderFns } from "./togglebutton.vue?vue&type=template&id=544664a6&"
import script from "./togglebutton.vue?vue&type=script&lang=js&"
export * from "./togglebutton.vue?vue&type=script&lang=js&"
import style0 from "./togglebutton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports